import { navigate } from 'gatsby'
import React, { useContext } from 'react'
import { Context } from '../../../context/app-context'
import { pushEventData } from '../../../utils/pushEventDataLayer'
import './modal-instructions.scss'
import Button from "../../atoms/button/button";

import bedroom_img from '../../../assets/images/modal-instructions/sceneario-bedroom.png';
import bathroom_img from '../../../assets/images/modal-instructions/sceneario-bathroom.png';
import ButtonClose from '../../atoms/button-close/button-close'
import BoxIcon from '../../atoms/box-icon/box-icon'

import useMediaQuery from '../../../utils/useMediaQuery'
import Show from '../../../utils/show'


const LOCALE = process.env.LOCALE;
const italatam = LOCALE === 'es-AR';

export default function ModalsInstructions({ handleStartGame, scene = 'bedroom' }) {
  const isMobile = useMediaQuery()
  const { dispatch } = useContext(Context)
  const LOCALE = process.env.LOCALE.toLowerCase();
  const onAccept = () => {
    pushEventData({
      event: 'Juego habitación',
      action: 'click juego',
      label: 'Haz clic acá!'
    })
    dispatch({ type: 'clear-modal' })
    handleStartGame();

  }
 

  const onclose = () => {
    dispatch({ type: 'clear-modal' })
    navigate('/')
  }

  const isBedroom = scene.indexOf('bedroom') === 0;
  const selectedSceneario = isBedroom ? bedroom_img : bathroom_img;

  return (
    <div className="f-palabras-modal-intructions">

      <ButtonClose className="f-palabras-modal-intructions__close " onClick={onclose} title="cerrar modal y regresar al home" />

      <h1 className="f-palabras-modal-intructions__title">
        {isBedroom ? <>Bienvenida a la Habitación Nosotras</> : <>Bienvenida al Baño del Loving</>}
      </h1>
      <div className="f-palabras-modal-intructions__container">
        <aside className='f-palabras-modal-intructions__aside-logo'>

          <figure>
            <img className='f-palabras-modal-intructions__logo' src={selectedSceneario} alt={"logo busca palabras en " + scene} />
          </figure>

          <h2 className='f-palabras-modal-intructions__ready-text'>  ¿Lista para jugar?</h2>
        </aside>
        <aside className='f-palabras-modal-intructions__aside-info'>


          <br />
          <div className='f-palabras-modal-intructions__list'>
            <div className='f-palabras-modal-intructions__list__item'>
              <BoxIcon type='search' />
              <p>
                <Show valid={isMobile}>
                  <Show valid={italatam}>
                    Movete alrededor del escenario, <b>buscá las palabras, hacé un tap sobre ellas y arrastralas a las casillas</b>
                    para formar la frase. El tiempo es oro, los segundos que te sobren al completar la frase,
                  </Show>
                  <Show valid={!italatam}>
                    Muévete alrededor del escenario, <b>busca las palabras, haz un tap sobre ellas y arrástralas a las casillas </b>
                    para formar la frase.
                  </Show>
                </Show>

                <Show valid={!isMobile}>
                  <b>{italatam ? 'Buscá' : 'Busca'} las palabras, encuéntralas, con un clic,<br /> {italatam ? 'arrastralas' : 'arrástralas'}</b>  hacia
                  la casilla correcta y {italatam ? 'formá' : 'forma'} la frase.
                </Show>
              </p>

            </div>
            <div className='f-palabras-modal-intructions__list__item'>
              <BoxIcon type='time' />
              <p>
                <Show valid={italatam}>
                  <b>Si no lográs completar la frase, ganarás 2 puntos por cada palabra encontrada.</b>
                  El tiempo es oro, los segundos que te sobren al completar la frase, también serán tu puntaje.
                </Show>
                <Show valid={!italatam}>
                  <b>Si no logras completar la frase, ganarás 2 puntos por cada palabra encontrada. </b>
                  El tiempo es oro, los segundos que te sobren al completar la frase, también serán tu puntaje.
                </Show>
              </p>
            </div>
            <div className='f-palabras-modal-intructions__list__item'>
              <BoxIcon type='video' />
              <p>
                <b>¡Dale play al video y gana 5 puntos adicionales! <br /></b>Dale skip si
                {italatam ? 'querés' : 'quieres'} continuar *(No ganarás puntos) 
              </p>
            </div>
          </div>

          <br />
          <div className='f-palabras-modal-intructions__playbuttonwrapper'>
            <Button onClick={onAccept} title="¡A jugar! - inicia el juego">¡{italatam ? 'Hacé' : 'Haz'} clic acá!</Button>
          </div>
        </aside>
      </div>

    </div>
  )
}
